var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "12.05 7.08 71.95 81.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.07,84.92V7.08H16.93V84.92H12.05v4H37.18V58.64H58.82V88.92H84v-4ZM32.29,48.18h-4V37.09h4Zm0-17h-4V20.09h4ZM50,48.18H46V37.09h4Zm0-17H46V20.09h4Zm17.71,17h-4V37.09h4Zm0-17h-4V20.09h4ZM41.18,62.64H54.82V88.92H41.18Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBuilding);
export default __webpack_public_path__ + "static/media/icon-building.6b787fbc147010f35925c26aa05c9fb9.svg";
export { ForwardRef as ReactComponent };